//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OCCResult",
  props: {
    result: Object,
    openInNewWindow: Boolean,
    formatDate: Function,
  },
  computed: {
  },
  methods: {
    scheduleNow() {

    }
  }
};
